module.exports = __webpack_public_path__ + "img/group-fail.fd2215ec.png";